import { DataTableRow } from '@boltenergy-be/design-system/dist/components/data-table/types'

export enum EventLogCells {
  DATE = 'date',
  TYPE = 'type',
  UPDATER = 'updater',
  AUTH_MODEL = 'authModel',
  USER = 'user',
  JSON = 'json'
}

export type EventLogDataRow = DataTableRow<EventLogCells>
